export const Comparators = {
    Unknown: 0,
    EqualTo: 1,
    NotEqualTo: 2,
    IsGreaterThan: 3,
    IsLesserThan: 4
};

export const ActionTypes = {
    Unknown: 0,
    ChangeValue: 1,
    UpdateVats: 2,
    SetInternalError: 3,
    RemoveExtraFee: 4
};

export const FeeTypes = {
    Unknown: 0,
    BaseFee: 1,
    WaitFee: 4,
    ContractFee: 5,
    PrebookFee: 6,
    GoodsFee: 7,
    AirportFee: 8,
    ServiceFee: 9,
    AidFee: 10,
    HandicapFee: 11,
    OtherExtraFee: 12,
    TariffFee: 13,
    StretcherFee: 14,
    ApproachFee: 15
};

export const FeeTypeLabels = {
    0: "Unknown",
    1: "Base fee",
    4: "Wait fee",
    5: "Contract fee",
    6: "Prebook fee",
    7: "Goods fee",
    8: "Airport fee",
    9: "Service fee",
    10: "Aid fee",
    11: "Handicap fee",
    12: "Other extra fee",
    13: "Tariff fee",
    14: "Stretcher fee",
    15: "Approach fee"
};

export const TransportEventConditionProperties = {
    EventType: "EventType",
    Cost: "Cost",
    TotalCharge: "TotalCharge",
    Deductible: "Deductible",
    WelfareTripType: "WelfareTripType",
    VatPercent: "VatPercent",
    HandicapFee: "HandicapFee",
    ValidationFailReasonCode: "ValidationFailReasonCode",
    ServiceProviderVatId: "ServiceProviderVatId"
};

export const RulesMixin = {
    data() {
        return {
            comparators: Comparators,
            actionTypes: ActionTypes,
            feeTypes: FeeTypes,
            feeTypeLabels: FeeTypeLabels,
            transportEventConditionProperties: TransportEventConditionProperties
        };
    },
    filters: {
        comparatorToSymbol: function(value) {
            switch (value) {
            case Comparators.Unknown:
                return "Not determined";
            case Comparators.EqualTo:
                return "=";
            case Comparators.NotEqualTo:
                return "!=";
            case Comparators.IsGreaterThan:
                return ">";
            case Comparators.IsLesserThan:
                return "<";
            };
        },
        actionToText: function(value) {
            switch (value.type) {
            case ActionTypes.ChangeValue:
                return "Set " + value.property + " value to " + value.value;
            case ActionTypes.UpdateVats:
                return "Update VAT values.";
            case ActionTypes.SetInternalError:
                return "Set event to internal validation failed state. Fail reason code: " + value.failCode + ", reason: " + value.value;
            case ActionTypes.RemoveExtraFee:
                return "Remove extra fee: " + (FeeTypeLabels[value.value] || "fee type " + value.value);
            default:
                return "Error in action. Please fix the action.";
            }
        },
        actionTypeToText: function(value) {
            switch (value) {
            case ActionTypes.ChangeValue:
                return "Set new value to property";
            case ActionTypes.UpdateVats:
                return "Update VAT values";
            case ActionTypes.SetInternalError:
                return "Set event to internal validation error";
            case ActionTypes.RemoveExtraFee:
                return "Remove extra fee";
            }
        }
    }
};
